import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTietHopDong } from "../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong";

export const BtnChiTietNhanVay = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} className="blue btn-link" onClick={handleShow}>
        {item.GiaoDichCode}
      </a>
      {show && (
        <ModalChiTietHopDong
          show={show}
          onHide={handleClose}
          nhanvayId={item.NhanVayId}
          item={item}
        />
      )}
    </>
  );
};
